module.exports = __webpack_public_path__ + "img/money_empty_icon.39a472c5.png";